import LazyLoad from "vanilla-lazyload";

let lazyLoadInstance = new LazyLoad( {
    "elements_selector": ".lazyload",
    "class_loaded": "lazyloaded",
    "class_entered": "lazyentered",
    "threshold": 50,
    callback_loaded: function ( img ) {
        img.parentNode.classList.add("loaded");
    }
} );
